import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum WeeklyMeetingDaysEnum {
    Sunday = 64 as any,
    Monday = 1 as any,
    Tuesday = 2 as any,
    Wednesday = 4 as any,
    Thursday = 8 as any,
    Friday = 16 as any,
    Saturday = 32 as any
}
class WeeklyMeetingDaysClass extends EnumWithDescription<WeeklyMeetingDaysEnum> {
    public readonly enum = WeeklyMeetingDaysEnum;
    public readonly enumName: string = "WeeklyMeetingDaysEnum";

    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<WeeklyMeetingDaysEnum>> = new Map([
        [
            "Sunday",
            {
                value: WeeklyMeetingDaysEnum.Sunday,
                name: "S"
            }
        ],
        [
            "Monday",
            {
                value: WeeklyMeetingDaysEnum.Monday,
                name: "M"
            }
        ],
        [
            "Tuesday",
            {
                value: WeeklyMeetingDaysEnum.Tuesday,
                name: "T"
            }
        ],
        [
            "Wednesday",
            {
                value: WeeklyMeetingDaysEnum.Wednesday,
                name: "W"
            }
        ],
        [
            "Thursday",
            {
                value: WeeklyMeetingDaysEnum.Thursday,
                name: "T"
            }
        ],
        [
            "Friday",
            {
                value: WeeklyMeetingDaysEnum.Friday,
                name: "F"
            }
        ],
        [
            "Saturday",
            {
                value: WeeklyMeetingDaysEnum.Saturday,
                name: "S"
            }
        ]
    ]);
}

export const WeeklyMeetingDays = new WeeklyMeetingDaysClass();
